"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzChartLine__Wrapper",
  componentId: "sc-i47cjd-0"
})(["\n  width: 100%;\n  height: ", ";\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  background-color: #fff;\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"], function (props) {
  return props.height;
});

var YAxisCnt = _styledComponents.default.div.withConfig({
  displayName: "OzChartLine__YAxisCnt",
  componentId: "sc-i47cjd-1"
})(["\n  flex-grow: 0;\n  flex-shrink: 1;\n"]);

var YAxis = _styledComponents.default.div.withConfig({
  displayName: "OzChartLine__YAxis",
  componentId: "sc-i47cjd-2"
})(["\n  height: calc(100% - ", "px);\n\n  display: grid;\n  grid-template-rows: repeat(", ", 1fr);\n  grid-gap: 0px;\n"], function (props) {
  return props.labelSpace ? 40 : 0;
}, function (props) {
  return props.steps + 1;
});

var YAxisLabel = _styledComponents.default.div.withConfig({
  displayName: "OzChartLine__YAxisLabel",
  componentId: "sc-i47cjd-3"
})(["\n  font-size: 10px;\n  letter-spacing: 0px;\n  text-align: right;\n  padding-right: 5px;\n  transform: translateY(6px);\n  display: flex;\n  justify-content: end;\n  align-items: end;\n  white-space: nowrap;\n"]);

var ContentCnt = _styledComponents.default.div.withConfig({
  displayName: "OzChartLine__ContentCnt",
  componentId: "sc-i47cjd-4"
})(["\n  flex-grow: 1;\n  flex-shrink: 1;\n  position: relative;\n"]);

var Content = _styledComponents.default.div.withConfig({
  displayName: "OzChartLine__Content",
  componentId: "sc-i47cjd-5"
})(["\n  width: 100%;\n  height: calc(100% - ", "px);\n  position: relative;\n"], function (props) {
  return props.labelSpace ? 40 : 0;
});

var YAxisLineCnt = _styledComponents.default.div.withConfig({
  displayName: "OzChartLine__YAxisLineCnt",
  componentId: "sc-i47cjd-6"
})(["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  display: grid;\n  grid-template-rows: repeat(", ", 1fr);\n  grid-gap: 0px;\n"], function (props) {
  return props.steps + 1;
});

var YAxisLine = _styledComponents.default.div.withConfig({
  displayName: "OzChartLine__YAxisLine",
  componentId: "sc-i47cjd-7"
})(["\n  border-bottom: 1px dashed ", ";\n"], function (props) {
  return props.style && props.style.color ? props.style.color : "#dedede";
});

var YAxisLimit = _styledComponents.default.div.withConfig({
  displayName: "OzChartLine__YAxisLimit",
  componentId: "sc-i47cjd-8"
})(["\n  position: absolute;\n  bottom: ", "%;\n  left: 0px;\n  width: 100%;\n  border-bottom: 1px solid ", ";\n"], function (props) {
  return props.value;
}, function (props) {
  return props.color;
});

var DefaultLimitLabel = _styledComponents.default.div.withConfig({
  displayName: "OzChartLine__DefaultLimitLabel",
  componentId: "sc-i47cjd-9"
})(["\n  position: absolute;\n  bottom: 0px;\n  left: 0px;\n  padding: 1px 5px;\n  font-size: 10px;\n  background-color: ", ";\n  color: #ffffff;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n"], function (props) {
  return props.color;
});

var PointsCnt = _styledComponents.default.div.withConfig({
  displayName: "OzChartLine__PointsCnt",
  componentId: "sc-i47cjd-10"
})(["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  display: grid;\n  grid-template-columns: repeat(", ", 1fr);\n  grid-gap: 5px;\n"], function (props) {
  return props.columns;
});

var PointColumn = _styledComponents.default.div.withConfig({
  displayName: "OzChartLine__PointColumn",
  componentId: "sc-i47cjd-11"
})(["\n  position: relative;\n  height: ", "%;\n  align-self: end;\n\n  &:after{\n    content: \"\";\n    display: block;\n    position: absolute;\n    bottom: 0px;\n    left: 0px;\n    width: 100%;\n    ", "\n\n  }\n"], function (props) {
  return props.height;
}, function (props) {
  return props.empty ? "\n      height: 100%;\n      background-color:  " + (props.barColor ? props.barColor : "#E8EBED66") + ";\n    " : null;
});

var Point = _styledComponents.default.div.withConfig({
  displayName: "OzChartLine__Point",
  componentId: "sc-i47cjd-12"
})(["\n    cursor: ", ";\n    position: absolute;\n    bottom: calc(", "% - ", "px);\n    left: calc(50% - ", "px);\n    width: ", "px;\n    height: ", "px;\n\n    & span{\n      display: none;\n      position: absolute;\n      white-space: nowrap;\n      bottom: 12px;\n      text-align: center;\n      font-size: 10px;\n      letter-spacing: 0px;\n\n      margin-left: 50%;\n      transform: translateX(-50%);\n\n      z-index: 9;\n    }\n    &:hover span{\n      display: block;\n    }\n\n\n\n    &:after{\n      z-index: 2;\n      display: block;\n      content: \"\";\n      height: ", "px;\n      bottom: ", "px;\n      left: ", "px;\n      position: absolute;\n      width: calc(var(--hypotenuse) * 1px);\n      transform: rotate(calc(var(--angle) * 1deg));\n      transform-origin: top left;\n      background-color: ", ";\n    }\n\n\n    &:before{\n      z-index: 3;\n      display: block;\n      content: \"\";\n      position: absolute;\n      bottom: ", "px;\n      left: ", "px;\n      width: ", "px;\n      height: ", "px;\n      border-radius: 100%;\n      background-color: ", ";\n      border: ", "px solid ", ";\n      box-sizing: content-box;\n    }\n\n    &:hover:before{\n      background-color: ", ";\n    }\n"], function (props) {
  return props.hasCallback ? "pointer" : "default";
}, function (props) {
  return props.value;
}, function (props) {
  return props.styleDots && props.styleDots.size ? props.styleDots.size / 2 : 5;
}, function (props) {
  return props.styleDots && props.styleDots.size ? props.styleDots.size / 2 : 5;
}, function (props) {
  return props.styleDots && props.styleDots.size ? props.styleDots.size : 10;
}, function (props) {
  return props.styleDots && props.styleDots.size ? props.styleDots.size : 10;
}, function (props) {
  return props.styleLines && props.styleLines.size ? props.styleLines.size : 2;
}, function (props) {
  return props.styleDots && props.styleDots.size ? (props.styleDots.size - (props.styleLines && props.styleLines.size ? props.styleLines.size : 2)) / 2 : 5;
}, function (props) {
  return props.styleDots && props.styleDots.size ? (props.styleDots.size - (props.styleLines && props.styleLines.size ? props.styleLines.size : 2)) / 2 : 5;
}, function (props) {
  return props.styleLines && props.styleLines.color ? props.styleLines.color : "#687fe266";
}, function (props) {
  return props.styleDots && props.styleDots.borderSize ? -props.styleDots.borderSize : 0;
}, function (props) {
  return props.styleDots && props.styleDots.borderSize ? -props.styleDots.borderSize : 0;
}, function (props) {
  return props.styleDots && props.styleDots.size ? props.styleDots.size : 10;
}, function (props) {
  return props.styleDots && props.styleDots.size ? props.styleDots.size : 10;
}, function (props) {
  return props.styleDots && props.styleDots.color ? props.styleDots.color : "#687fe299";
}, function (props) {
  return props.styleDots && props.styleDots.borderSize ? props.styleDots.borderSize : 0;
}, function (props) {
  return props.styleDots && props.styleDots.borderColor ? props.styleDots.borderColor : "#687fe2";
}, function (props) {
  return props.styleDots && props.styleDots.hoverColor ? props.styleDots.hoverColor : "#687fe2";
}); // const XAxis = styled.div`
//   width: 100%;
//   height: 30px;
//   display: grid;
//   grid-template-columns: repeat(${props => props.columns}, 1fr);
//   grid-gap: 15px;
// `;


var XAxisLabel = _styledComponents.default.div.withConfig({
  displayName: "OzChartLine__XAxisLabel",
  componentId: "sc-i47cjd-13"
})(["\n  position: absolute;\n  bottom: -40px;\n  width: 100%;\n  font-size: 7px;\n  letter-spacing: 0px;\n  text-align: center;\n  color: ", "\n"], function (props) {
  return props.color ? props.color : "inherit";
});

var calcHypotenuse = function calcHypotenuse(value, nextValue) {
  if (nextValue) {
    var x = nextValue.x > value.x ? nextValue.x - value.x : value.x - nextValue.x;
    var y = nextValue.y > value.y ? nextValue.y - value.y : value.y - nextValue.y;
    var hypotenuse = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    return hypotenuse;
  } else {
    return null;
  }
};

var calcAngle = function calcAngle(value, nextValue) {
  if (nextValue) {
    // var x = nextValue.x > value.x ? nextValue.x - value.x : value.x - nextValue.x;
    var y = nextValue.y > value.y ? nextValue.y - value.y : value.y - nextValue.y;
    var angleRad = Math.asin(y / calcHypotenuse(value, nextValue));
    var angle = angleRad * (180 / Math.PI); // console.log("AN: " + angle);

    return nextValue.y > value.y ? angle : -angle; // return null;
  } else {
    return null;
  }
};

var OzChartLine = function OzChartLine(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? "300px" : _ref$height,
      _ref$limits = _ref.limits,
      limits = _ref$limits === void 0 ? [] : _ref$limits,
      max = _ref.max,
      steps = _ref.steps,
      values = _ref.values,
      style = _ref.style,
      _ref$fnCallback = _ref.fnCallback,
      fnCallback = _ref$fnCallback === void 0 ? null : _ref$fnCallback,
      _ref$fnFormatValue = _ref.fnFormatValue,
      fnFormatValue = _ref$fnFormatValue === void 0 ? function (ret) {
    return ret;
  } : _ref$fnFormatValue,
      _ref$fnFormatY = _ref.fnFormatY,
      fnFormatY = _ref$fnFormatY === void 0 ? function (ret) {
    return ret;
  } : _ref$fnFormatY;
  var maxY = max ? max : Math.max.apply(Math, (0, _toConsumableArray2.default)(values.map(function (item) {
    return item.value;
  })));
  var letMaxYLength = parseInt(maxY).toString().length;

  if (letMaxYLength > 2) {
    maxY = (parseInt(maxY.toString().substring(0, 2)) + 1) * Math.pow(10, letMaxYLength - 2);
  } else {
    maxY = (parseInt(maxY.toString().substring(0, 1)) + 1) * Math.pow(10, letMaxYLength - 1);
  }

  if (Math.max.apply(Math, (0, _toConsumableArray2.default)(limits.map(function (item) {
    return item.value;
  }))) > maxY) {
    maxY = Math.max.apply(Math, (0, _toConsumableArray2.default)(limits.map(function (item) {
      return item.value;
    })));
  }

  var tempCoords = [];
  var coords = [];

  if (!steps) {
    for (var i = 10; i > 2; i--) {
      if (maxY * 2 % i === 0) {
        steps = i;
        break;
      }
    } // if(!steps){
    //   maxY++;
    //   for(let i=12; i>2; i--){
    //     if((maxY)*2 % i === 0){
    //       steps = i;
    //       break;
    //     }
    //   }
    // }


    if (!steps) {
      steps = 10;
    }
  }

  var labelsY = [];
  var stepY = maxY / steps;

  for (var _i = steps; _i >= 0; _i--) {
    if (stepY < 1) {
      labelsY.push((_i * stepY).toFixed(1));
    } else {
      labelsY.push(_i * stepY);
    }
  }

  (0, _react.useEffect)(function () {
    for (var _i2 = 0; _i2 < coords.length - 1; _i2++) {
      if (coords[_i2]) {
        var nextCoords = null;

        for (var j = _i2 + 1; j <= coords.length - 1; j++) {
          if (coords[j]) {
            nextCoords = coords[j];
            break;
          }
        }

        coords[_i2].el.setAttribute("style", "--hypotenuse: " + calcHypotenuse(coords[_i2], nextCoords) + ";" + "--angle: " + calcAngle(coords[_i2], nextCoords) + ";");
      }
    }
  }, [coords]);
  return __jsx(Wrapper, {
    height: height
  }, !(style && style.yAxis && !style.yAxis.showLabels) ? __jsx(YAxisCnt, null, __jsx(YAxis, {
    steps: steps,
    labelSpace: !(style && style.xAxis && !style.xAxis.showLabels)
  }, labelsY.map(function (item, i) {
    return __jsx(YAxisLabel, {
      key: i
    }, fnFormatY(item));
  }))) : null, __jsx(ContentCnt, null, __jsx(Content, {
    labelSpace: !(style && style.xAxis && !style.xAxis.showLabels)
  }, __jsx(YAxisLineCnt, null, labelsY.map(function (item, i) {
    return __jsx(YAxisLine, {
      key: i,
      style: i !== labelsY.length - 1 ? style && style.yLines ? style.yLines : null : style && style.xAxis ? style.xAxis : null
    });
  }), limits.length > 0 ? limits.map(function (item, i) {
    return __jsx(YAxisLimit, {
      key: i,
      className: "limit",
      value: item.value * (steps * 100 / (steps + 1)) / maxY,
      color: item.color ? item.color : "#4ad384",
      labelText: item.label ? item.label : "Limit",
      labelColor: style && style.limit && style.limit.labelColor ? style.limit.labelColor : "#ffffff"
    }, item.labelComponent ? item.labelComponent : __jsx(DefaultLimitLabel, {
      color: item.color ? item.color : "#4ad384"
    }, item.labelText ? item.labelText : "Limit"));
  }) : null), __jsx(PointsCnt, {
    columns: values.length
  }, values.map(function (item, i) {
    return __jsx(PointColumn, {
      onClick: fnCallback ? function () {
        return fnCallback(item);
      } : function () {},
      key: i,
      height: steps * 100 / (steps + 1),
      empty: item.value === null,
      value: item.value * 100 / maxY,
      label: fnFormatValue(item.value),
      barColor: item.style && item.style.barColor ? item.style.barColor : null
    }, item.value !== null ? __jsx(Point, {
      styleDots: style && style.dots ? style.dots : null,
      styleLines: style && style.lines ? style.lines : null,
      hasCallback: fnCallback ? 1 : 0,
      ref: function ref(el) {
        if (!el) return;
        var tempCoord = {
          el: el,
          x: el.getBoundingClientRect().left,
          y: el.getBoundingClientRect().top
        };
        tempCoords[i] = tempCoord;

        if (tempCoords.length === values.filter(function (el) {
          return el.value !== null;
        }).length) {
          coords = tempCoords;
        }
      },
      value: item.value * 100 / maxY,
      hypotenuse: function hypotenuse() {
        return calcHypotenuse(i);
      },
      angle: function angle() {
        return calcAngle(i);
      }
    }, __jsx("span", null, fnFormatValue(item.value))) : null, !(style && style.xAxis && !style.xAxis.showLabels) ? __jsx(XAxisLabel, {
      key: i,
      color: item.style && item.style.labelColor ? item.style.labelColor : null
    }, item.label) : null);
  })))));
};

var _default = OzChartLine;
exports.default = _default;